// extracted by mini-css-extract-plugin
export default {"modal":"Welcome--modal--8o-Al","modal-actions":"Welcome--modal-actions--p7oTG","modalActions":"Welcome--modal-actions--p7oTG","avatar":"Welcome--avatar--eo5pO"};